import React, { useState } from 'react';

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";

import Done from "@material-ui/icons/Done";
import Chat from "@material-ui/icons/Chat";
import IconButton from "@material-ui/core/IconButton";
import ModalValidateStorage from "components/ModalValidateStorage/ModalValidateStorage.js";
import ModalValidateAll from "components/ModalValidateAll/ModalValidateAll.js";
import ModalAddCommentStorage from "components/ModalAddCommentStorage/ModalAddCommentStorage.js";

import Tooltip from "@material-ui/core/Tooltip";

import { makeStyles } from "@material-ui/core/styles";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";

import { formatDate } from "services/formatDate.js"

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    acctAll: {
        float: "right"
    }
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

function TableStorageOperator({ storage, loadTotal, loadStorage, toogle }) {
    const classes = useStyles();
    const classes2 = useStyles2();

    const [modalShow, setModalShow] = useState(false);
    const [modalAllShow, setModalAllShow] = useState(false);
    const [modalMessageShow, setModalMessageShow] = useState(false);
    const [index, setIndex] = useState({ id: 2 });
    const [indexMessage, setIndexMessage] = useState({ id: 1 });
    const loadStorage2 = () => loadStorage();
    function callModal(index) {
        setIndex(index);
        setModalShow(true);
    }

    function callModalMessage(index) {
        setIndexMessage(index);
        setModalMessageShow(true);
    }

    function callModalValidateAll(index) {
        setIndex(index);
        setModalAllShow(true);
    }

    function getStorages() {
        let teste = [];
        for (let i = 0; i < storage.length; i++) {
            teste[i] = [];
            teste[i].push(storage[i].nf)
            if (storage[i].id_product === 27 || storage[i].id_product === 49) {
                teste[i].push(storage[i].weight)
                teste[i].push((storage[i].weight / storage[i].box))
            } else {
                teste[i].push(storage[i].amount)
                teste[i].push((storage[i].amount / storage[i].box))
            }
            teste[i].push(storage[i].name)
            teste[i].push(formatDate(storage[i].date_of_issued))
            teste[i].push(
                <CardIcon>
                    <Icon title={storage[i].validated ? "Validado" : "Não validado"}>{storage[i].validated ? "done" : "clear"}</Icon>
                </CardIcon>
            )
            teste[i].push(<div className={classes2.tableActions}>
                {!storage[i].validated ?
                    <Tooltip
                        id="tooltip-top"
                        title="Validar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Done"
                            className={classes2.tableActionButton}
                            onClick={() => callModal(storage[i])}
                        >
                            <Done
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.edit
                                }

                            />
                        </IconButton>

                    </Tooltip>
                    : <div />
                }
                <Tooltip
                    id="tooltip-top"
                    title="Reportar erro"
                    placement="top"
                    classes={{ tooltip: classes2.tooltip }}
                >
                    <IconButton
                        aria-label="Chat"
                        className={classes2.tableActionButton}
                        onClick={() => callModalMessage(storage[i])}
                    >
                        <Chat
                            className={
                                classes2.tableActionButtonIcon + " " + classes2.edit
                            }

                        />
                    </IconButton>

                </Tooltip>
            </div>)
        }
        return teste;
    }


    return (
        <GridItem xs={12} sm={12} md={12}>
            {storage[0] !== undefined ? (
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader className={classes.zindex} color={storage[0].validated ? "success" : "danger"}>
                            <h4 className={classes.cardTitleWhite}>Estoque</h4>
                            {!toogle ?
                                <div className={classes.acctAll}>
                                    <Tooltip
                                        id="tooltip-top"
                                        title="Validar todos"
                                        placement="top"
                                        classes={{ tooltip: classes2.tooltip }}
                                    >
                                        <IconButton
                                            aria-label="Done"
                                            className={classes2.tableActionButton}
                                            onClick={() => callModalValidateAll(storage[0])}
                                        >
                                            <Done
                                                className={
                                                    classes2.tableActionButtonIcon + " " + classes2.edit2
                                                }
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                : <div></div>}
                            <p className={classes.cardCategoryWhite}></p>
                        </CardHeader>
                        <CardBody>
                            <Table
                                tableHeaderColor="danger"
                                tableHead={["NF", "Quantidade", "Quantidade de caixa", "Produto", "Data de emissão", "Status", "Ações"]}
                                tableData={getStorages()}
                            />
                        </CardBody>
                    </Card>
                    <ModalValidateStorage key={String("Val_" + index.id)} props={index} loadStorage={loadStorage} loadTotal={loadTotal} show={modalShow}
                        onHide={() => setModalShow(false)} />
                    <ModalAddCommentStorage key={String("Add_" + indexMessage.id)} props={indexMessage} type={"storage"} show={modalMessageShow}
                        onHide={() => setModalMessageShow(false)} />
                    <ModalValidateAll key={String("ValAll_" + index.nf)} props={index} loadStorage={loadStorage2} loadTotal={loadTotal} show={modalAllShow} onHide={() => setModalAllShow(false)} type="entradas"></ModalValidateAll>
                </GridItem >
            ) : <div></div>}
        </GridItem>
    );
}

export default TableStorageOperator;